import React, {PureComponent} from 'react';

export default class Tweet extends PureComponent {
    constructor(props) {
        super();
    }

    render() {
        const tweet = this.props.data;
        const profileImg = {
            backgroundImage: `url('${tweet.profile_pic}')`,
        };

        return (
            <div className="tweet pt2 pb2 pr2">
                <div className="tweet__image bg-center" style={profileImg}/>
                <div className="tweet__content">
                    <div className="tweet__header">
                        <span className="tweet__name">{tweet.author}</span>
                        <span className="tweet__handle">{tweet.handle}</span>
                        {/*<span className="tweet__time">{tweet.time}</span>*/}
                    </div>
                    <p>{tweet.tweet}</p>
                </div>
            </div>
        )
    }
}
